import { categoriesSlice } from './slices/categories-slice';

export const configurationCategoriesReducer = categoriesSlice.reducer;
